export default __webpack_public_path__ + "1bd028fa6285de652fa8c492f8b20c06.wav";